var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{ref:"headerTop",staticClass:"banner-container"},[_c('div',{staticClass:"banner-content box1200"})]),_c('main',{ref:"myDiv",staticClass:"main"},[_c('div',{staticClass:"box1200"},[_c('div',{staticClass:"content-container"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }